const Keys = {
    API_URL: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_DEV_URL:process.env.REACT_APP_API_URL,
    COOKIE_DOMAIN: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_SUBCONTRACT_DOMAIN_DEV:process.env.REACT_APP_SUBCONTRACT_DOMAIN,
    SUBCONTRACTOR_DOMAIN: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_SUBCONTRACT_PORTAL_DEV:process.env.REACT_APP_SUBCONTRACT_PORTAL,
}

export default Keys;